import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getVariationMasterByIdApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const getVariationMasterById = createAsyncThunk('getVariationMasterById', async (payload) => {
  // console.log('payload', payload);
  return await getVariationMasterByIdApi(payload);
});

const getVariationMasterByIdSlice = createSlice({
  name: 'getVariationMasterById', // Unique Name
  initialState,
  reducers: {
    getVariationMasterByIdReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getVariationMasterById.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(getVariationMasterById.fulfilled, (state, action) => {
        const { message = '', data = [], payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(getVariationMasterById.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { getVariationMasterByIdReset } = getVariationMasterByIdSlice.actions;

export default getVariationMasterByIdSlice.reducer;
